import { render, staticRenderFns } from "./asgctMobile.vue?vue&type=template&id=0c3f0610&scoped=true"
import script from "./asgctMobile.vue?vue&type=script&lang=js"
export * from "./asgctMobile.vue?vue&type=script&lang=js"
import style0 from "./asgctMobile.vue?vue&type=style&index=0&id=0c3f0610&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3f0610",
  null
  
)

export default component.exports